import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map, capitalize,
} from 'lodash';
import ReactToPrint from 'react-to-print';
import ReactExport from 'react-export-excel';
import {
  commaFormatted,
  normalizeAmount,
} from '../../../../utils/transformer.util';
import { Select, Button, SearchSelect } from '../../../../components/base/index';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class LaporanBantuan extends PureComponent {
  constructor(props) {
    super(props);

    this._onFormChange = this._onFormChange.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onClickEdit = this._onClickEdit.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._initializeData = this._initializeData.bind(this);
    this.getYearsOfEducationsOptions = this.getYearsOfEducationsOptions.bind(this);
    this.getPrmPaymentsGeneralAll = this.getPrmPaymentsGeneralAll.bind(this);
    // this.renderExcel = this.renderExcel.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;

    this.state = {
      page: 1,
      content: initialContent,
      list: [],
      filters: {
        year: '',
      },
      list: [],
      isPrint: true,
      isClick: false,
      form: {
        value: {
          currents_year: '',
          // years_now,
          levels_id,
          listreport: [],
          listreport2: [],
          user_id: user.id,
        },
        error: {
          listreport: [],
          listreport2: [],
        },
      },
      param: {},
      filtered: false,
    };
    this.checkboxRefs = [];
  }

  componentDidMount() {
    const { user } = this.props;
    const { school_unit, organizations_id, user_group } = user;
    const { levels_id } = school_unit;
    const { content, filters, form } = this.state;
    const { value } = form;
    let savedFilters = JSON.parse(window.localStorage.getItem('bantuanFilters')) || filters;
    let savedForm = JSON.parse(window.localStorage.getItem('bantuanForm')) || '';
    if (savedForm != '' && user.id != savedForm.value.user_id) {
      savedForm = '';
      savedFilters = filters;
    }
    console.log(savedFilters);

    this._initializeData(savedFilters);
    this.getPrmPaymentsGeneralAll();

    if (savedForm != '') {
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            levels_id: savedForm.value.levels_id,
            // units_id: savedFilters.units_id,
            update: true,
          },
        },
      }));

      if (user_group.name === 'pusat') {
        this.getYearsOfEducationsOptions({ units_id: savedForm.value.units_id ? savedForm.value.units_id.value : '' });
      //   this._getParamOptionsAcademics("classrooms", {
      //    levels_id: savedForm.value.levels_id,
      //    organizations_id,
      //    units_id: savedForm.value.units_id.value
      //  });
      }
    }
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { school_unit, user_group } = user;
    if (user_group.name !== 'pusat') {
      const paramTypes = ['classrooms', 'levels'];

      // paramTypes.forEach((type) => {
      //   this._getParamOptionsAcademics(type);
      // });
      await this.getYearsOfEducationsOptions({ units_id: school_unit.id });
    }

    await this._getSchoolUnitsOptions();

    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        tipe: savedFilters.tipe,
      },
    }), () => {
      // commonActions.setLoading({ show: true });
      this._onSearchContent();
    });
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async getYearsOfEducationsOptions(filters = {}) {
    const { getYearsOfEducationsOptions } = this.props;
    const res = await getYearsOfEducationsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran selanjutnya
        if (res[idx + 1]) {
          this.setState(prevState => ({
            ...prevState,
            filters: {
              ...prevState.filters,
              year: res[idx + 1].value.toString().substring(2),
            },
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                currents_year: res.value,
              },
            },
          }));
        }
      }
    });

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async getPrmPaymentsGeneralAll() {
    const { getPrmPaymentsGeneralAll } = this.props;
    const res = await getPrmPaymentsGeneralAll();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        prm_payments: res,
      },
    }));
  }

  _onFormChange(event) {
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      this._onSearchContent();
    });
  }

  _onChangeFilter(e) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { target } = e;
    const { value, name } = target;
    const { form, param } = this.state;

    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      if (name === 'jenis') {
        const nick_name = param.prm_payments.find(i => i.value == value) ? param.prm_payments.find(i => i.value == value).nick_name : '';

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              nick_name,
            },
          },
        }));
      }

      if (name === 'units_id') {
        const param = this.state.param.units;
        console.log(value.value);
        const levels_units = param.find(i => i.value == value.value) ? param.find(i => i.value == value.value).attributes.levels_id : '';

        console.log(levels_units);
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              classrooms_id: '',
              levels_id: levels_units,
              units_id: value,
              payments_id: '',
              listreport: [],
              month: '',
            },
          },
          filters: {
            ...prevState.filters,
            tipe: '',
            jenis: '',
          },
        }));
        this.getYearsOfEducationsOptions({ units_id: value.value });
      }
      window.localStorage.setItem('bantuanFilters', JSON.stringify(this.state.filters));
      window.localStorage.setItem('bantuanForm', JSON.stringify(this.state.form));
      this._onSearchContent();
    });
  }

  _onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/tagihan-siswa/create-invoice/tidak-rutin', { data: val, isEdit: true });
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { jenis, period, tipe } = filters;
    const {
      currents_year, years_now, payments_id, month,
    } = form.value;
    this.setState({
      content: initialContent,
    },
    async () => {
      try {
        const {
          handleReportPPDBSpp, handleReportPPDBUpp, handleReportPPDBOfflineSpp, handleReportPPDBSppGeneral, handleReportPPDBUppGeneral,
          handleReportPPDBOfflineUpp, handleReportPPDBSppF07, handleReportPPDBUppF07, handleListStudentsClassDivGeneral,
          handleReportPPDBSppRicci, handleReportPPDBUppRicci, handleReportSupportRutin, handleReportSupportNonRutin,
        } = this.props;
        const { user } = this.props;
        const { school_unit, organizations_id, user_group } = user;
        { console.log(school_unit.id); }
        let result = {};
        const result2 = {};
        const year = new Date().getFullYear();

        if (tipe === 'spp') {
          result = await handleReportSupportRutin({
            ...params,
            currents_year: currents_year || year,
            units_id: user_group.name == 'pusat' ? filters.units_id : school_unit.id,
            organizations_id,
            payments_id,
            month,
            filters,
          });
        } else if (tipe === 'upp') {
          result = await handleReportSupportNonRutin({
            ...params,
            organizations_id,
            payments_id,
            units_id: user_group.name == 'pusat' ? filters.units_id : school_unit.id,
            filters,
          });
        }

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listreport: result,
            },
          },
        }));
      } catch (err) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listreport: [],
            },
          },
        }));
      }
      // finally {
      //   commonActions.setLoading({ show: false });
      // }
    });
  }

  async renderExcel() {
    const {
      form, filters, isClick, isPrint,
    } = this.state;
    const { value } = form;
    const { jenis, period, tipe } = filters;
    const {
      currents_year, years_now, payments_id, month,
    } = form.value;
    const { handleReportSupportRutinExcel, handleReportSupportNonRutinExcel } = this.props;
    const { user } = this.props;
    const { school_unit, organizations_id, user_group } = user;
    if (tipe == 'spp') {
      await handleReportSupportRutinExcel({
        currents_year,
        units_id: user_group.name == 'pusat' ? filters.units_id : school_unit.id,
        organizations_id,
        payments_id,
        month,
        filters,
      });
    } else {
      await handleReportSupportNonRutinExcel({
        units_id: user_group.name == 'pusat' ? filters.units_id : school_unit.id,
        organizations_id,
        payments_id,
        filters,
      });
    }
  }

  render() {
    const {
      form, filters, param, page, isPrint, data_idx, isClick,
    } = this.state;
    const {
      listreport, listreport2, years_now, currents_year, nick_name, month, payments_id, units_id,
    } = form.value;
    const { jenis, tipe, period } = filters;
    const { user } = this.props;
    const {
      school_unit, organization, organizations_id, user_group,
    } = user;
    const { logo_right } = organization;
    const { prm_payments } = param;

    const componentRef = React.createRef();
    const prm_payments_bantuan = prm_payments ? prm_payments.filter(item => item.is_type == 0) : '';
    const prm_payments_main = prm_payments ? prm_payments.filter(item => item.is_type == 1) : '';
    const prm_rutin = prm_payments_main ? prm_payments_main.filter(item => item.is_routine == 1) : '';
    const prm_non_rutin = prm_payments_main ? prm_payments_main.filter(item => item.is_routine == 0) : '';
    const prm_payments_nick = prm_payments_bantuan ? prm_payments_bantuan.filter(item => item.nick_name == nick_name) : '';

    const prm_bantuan_rutin = prm_payments_nick ? prm_payments_nick.filter(item => item.is_routine == 1) : '';
    const prm_bantuan_non = prm_payments_nick ? prm_payments_nick.filter(item => item.is_routine == 0) : '';
    const printTest = `
    @media print {
      @page {
        page-break-inside: avoid;
      }
      * {
        -webkit-print-color-adjust: exact;
      }
    }`;


    const prm_jenis = [
      { label: organizations_id == 3 ? 'SPP' : 'RUTIN', value: 'spp' },
      { label: organizations_id == 3 ? 'DPP/UPP' : 'NON RUTIN', value: 'upp' },
    ];
    const bulan = [
      { label: 'Juli', value: '7' },
      { label: 'Agustus', value: '8' },
      { label: 'September', value: '9' },
      { label: 'Oktober', value: '10' },
      { label: 'November', value: '11' },
      { label: 'Desember', value: '12' },
      { label: 'Januari', value: '1' },
      { label: 'Februari', value: '2' },
      { label: 'Maret', value: '3' },
      { label: 'April', value: '4' },
      { label: 'Mei', value: '5' },
      { label: 'Juni', value: '6' },
    ];

    const lunas = 0;
    const ttllunas = 0;
    const subtotal = 0;
    let total = 0;

    let title = '';
    if (tipe == 'spp') {
      title = organizations_id == 3 ? 'SPP' : 'RUTIN';
    }
    if (tipe == 'upp') {
      title = organizations_id == 3 ? 'DPP/UPP' : 'NON RUTIN';
    }

    // console.log(units_id)
    const units_label = units_id ? units_id.label : '';
    const units_value = units_id ? units_id.value : '';
    const name_payments = prm_payments_nick
      ? (prm_payments_nick.find(i => i.value == payments_id)
        ? prm_payments_nick.find(i => i.value == payments_id).label : '')
      : '';

    return (
      <div className="student-list">
        <div className="budget__title">
          <h1>Laporan Bantuan</h1>
          <hr />
        </div>

        <div className="absensi-rekap__custom-form">
          {(user_group.name === 'pusat')
            ? (
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <SearchSelect
                    noMargin
                    async={false}
                    name="units_id"
                    list={param.units}
                    inputArray
                    onClick={this._onChangeFilter}
                    placeholder="Pilih Unit"
                    value={form.value.units_id}
                    rightIcon="icon-search"
                    label="Pilih Unit"
                  />
                </div>
              </div>
            )
            : ''}
          {console.log(tipe)}
          {console.log(jenis)}
          {console.log(units_value)}
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <Select
                name="tipe"
                label="Tipe Pembayaran"
                onChange={this._onChangeFilter}
                data={prm_jenis}
                placeholder="Pilihan"
                value={tipe}
                disabled={!((user_group.name !== 'pusat' || units_value))}
              />
            </div>
            <div className="absensi-rekap__custom-form-column__field">
              <Select
                name="jenis"
                label="Jenis Pembayaran"
                onChange={this._onChangeFilter}
                data={tipe == 'spp' ? prm_rutin : prm_non_rutin}
                placeholder="Pilihan"
                value={jenis}
                disabled={!tipe}
              />
            </div>
          </div>
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <Select
                name="payments_id"
                label="Jenis Bantuan"
                onChange={this._onFormChange}
                data={tipe == 'spp' ? prm_bantuan_rutin : prm_bantuan_non}
                placeholder="Pilihan"
                value={payments_id}
                disabled={!jenis}
              />
            </div>
            {tipe == 'spp'
              ? (
                <div className="absensi-rekap__custom-form-column__field">
                  <Select
                    name="currents_year"
                    label="Tahun Ajaran"
                    onChange={this._onFormChange}
                    data={param.periods}
                    // disabled={user_group.name == 'pusat'? false : true}
                    // data={years}
                    placeholder="Pilihan"
                    value={currents_year}
                  />
                </div>
              )
              : <div className="absensi-rekap__custom-form-column__field" />
          }
          </div>
          {tipe == 'spp'
            ? (
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <Select
                    name="month"
                    label="Bulan"
                    onChange={this._onFormChange}
                    data={bulan}
                    placeholder="Pilihan"
                    value={month}
                  />
                </div>
                <div className="absensi-rekap__custom-form-column__field" />
              </div>
            )
            : ''}
        </div>

        <br />
        <div className="beginning-balance__button-wrapper">
          <ReactToPrint
            pageStyle={printTest}
            onBeforeGetContent={() => new Promise((resolve) => {
              setTimeout(() => {
                this.setState({ isPrint: false },
                  resolve);
              }, 500);
            })}
            onAfterPrint={() => this.setState({ isPrint: true })}
            trigger={() => (
              // <div className="manage-registration__footer">
              <Button title="Cetak/Simpan PDF" />
              // </div>
            )}
            content={() => componentRef.current}
          />
          <Button
            title="Ekspor Excel"
            onClick={() => this.renderExcel()}
          />
          {/* <div style={{marginLeft: '0rem'}} className="student-list__button">
                {this.renderExcel()}
              </div> */}
        </div>
        {/* {isPrint? */}
        <form style={{ pageBreakInside: 'avoid', padding: '20px' }} ref={componentRef}>
          <div>
            <table className="table-report-header">
              <tr>
                <th rowSpan="2">
                  <img style={{ width: '70px' }} src={logo_right} />
                </th>
                <th style={{ paddingRight: '10rem' }}>
                  <h2>{user_group.name == 'pusat' ? units_label : school_unit.name}</h2>
                </th>
              </tr>
              <tr>
                <th style={{ paddingRight: '10rem' }}>
                  <h3>LAPORAN BANTUAN</h3>
                </th>
              </tr>
            </table>

            {(() => {
              if (!isEmpty(listreport) && tipe == 'spp') {
                return (
                  <>
                    <table className="laporan-ki4__table-test" style={{ width: 'unset' }}>
                      <tr>
                        <td>Jenis Pembayaran</td>
                        <td>&emsp; : {title}</td>
                      </tr>
                      <tr>
                        <td>Tahun Ajaran</td>
                        <td>&emsp; : {currents_year ? `${currents_year}/${Number(currents_year) + 1}` : '-'}</td>
                      </tr>
                      <tr>
                        <td>Jenis Bantuan</td>
                        <td>&emsp; : {name_payments}</td>
                      </tr>
                    </table>
                    <br />
                    <table className="tablespp">
                      <thead>
                        <tr>
                          <th rowSpan={2}>No</th>
                          <th rowSpan={2}>No VA</th>
                          <th rowSpan={2}>Nama Siswa</th>
                          <th colSpan={12}>Nominal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          total = 0;
                        })()}
                        {map(listreport, (data, idx) => (
                          <tr key={`budget_row_${idx}`}>
                            {(() => {
                              data.id = data.no_va;
                              data.entrance_year = currents_year;
                            })()}
                            <td key={`table_index_${idx}`} style={{ textAlign: 'center' }}>
                              {idx + 1}
                            </td>
                            <td>{data.no_va}</td>
                            <td style={{ textTransform: 'capitalize' }}>{capitalize(data.full_name)}</td>
                            <td className="nominal">{commaFormatted(data.nominal_bantuan)}</td>
                            {(() => {
                              total += Number(data.nominal_bantuan);
                            })()}
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={3}>Total</th>
                          <th
                            className="nominal"
                            style={{
                              width: '90px', minWidth: '90px', maxWidth: '90px', textAlign: 'right',
                            }}
                          >{commaFormatted(total)}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </>
                );
              }
              if (!isEmpty(listreport) && tipe == 'upp') {
                return (
                  <>
                    <table className="laporan-ki4__table-test" style={{ width: 'unset' }}>
                      <tr>
                        <td>Jenis Pembayaran</td>
                        <td>&emsp; : {title}</td>
                      </tr>
                      <tr>
                        <td>Jenis Bantuan</td>
                        <td>&emsp; : {name_payments}</td>
                      </tr>
                    </table>
                    <br />
                    <table className="tablespp">
                      <thead>
                        <tr>
                          <th rowSpan={2}>No</th>
                          <th rowSpan={2}>No VA</th>
                          <th rowSpan={2}>Nama Siswa</th>
                          <th colSpan={12}>Nominal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(listreport, (data, idx) => (
                          <tr key={`budget_row_${idx}`}>
                            <td key={`table_index_${idx}`} style={{ textAlign: 'center' }}>
                              {idx + 1}
                            </td>
                            <td>{data.no_va ? data.no_va : data.temps_id}</td>
                            <td style={{ textTransform: 'capitalize' }}>{capitalize(data.full_name ? data.full_name : data.name_student_ppdb)}</td>
                            <td className="nominal">{commaFormatted(data.nominal)}</td>
                            {(() => {
                              total += Number(data.nominal);
                            })()}
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={3}>Total</th>
                          <th
                            className="nominal"
                            style={{
                              width: '90px', minWidth: '90px', maxWidth: '90px', textAlign: 'right',
                            }}
                          >{commaFormatted(total)}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </>
                );
              }
              if (tipe == undefined || tipe == '') {
                return (
                  <h2 style={{ textAlign: 'center' }}>Jenis Pembayaran belum dipilih.</h2>
                );
              }

              return (
                <h2 style={{ textAlign: 'center' }}>Data {currents_year} belum ada.</h2>
              );
            })()}
          </div>
        </form>

      </div>
    );
  }
}
LaporanBantuan.propTypes = {
  handleGetStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
LaporanBantuan.defaultProps = {
  handleGetStudent: noop,
};
